export const DialogSummaryName = 'dialogSummaryComponent';
